import { render, staticRenderFns } from "./cost.vue?vue&type=template&id=dff1e8c8&"
import script from "./cost.vue?vue&type=script&lang=js&"
export * from "./cost.vue?vue&type=script&lang=js&"
import style0 from "./cost.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports